import { css } from 'styled-components';
import { showPage } from './keyframes';

export function flexBox(flexFlow = 'row wrap', justifyContent = 'center', alingItems = 'center') {
  return css`
    display: flex;
    flex-flow: ${flexFlow};
    justify-content: ${justifyContent};
    align-items: ${alingItems};
  `;
}

export function fontFace(family, file, weight = 'normal') {
  return css`
    @font-face {
      font-family: ${family};
      src: url(${file});
      font-weight: ${weight};
    }
  `;
}

export function fontSize(sizeInPixel = 16) {
  return css`
    font-size: ${sizeInPixel / 16}rem;
  `;
}

export function heroGradient() {
  return css`
    background: linear-gradient(204.19deg, #121A3C 0%, #3E224C 20.43%, #FE3C49 87.73%, #FE3C49 112.5%);
  `;
}

export function heroMobileGradient() {
  return css`
    background: linear-gradient(242.15deg, #FE3C49 -2.89%, #FE3C49 35.88%, #3E224C 75.73%, #121A3C 98.53%);
  `;
}

export function headerGradient() {
  return css`
    background: linear-gradient(127.2deg, #FE3C49 12.2%, #121A3C 92.16%);
  `;
}

export function headerMobileGradient() {
  return css`
    background: linear-gradient(61.2deg, #121A3C -36.8%, #FE3C45 92.16%);
  `;
}

export function titleMenuMobileGradient() {
  return css`
    background: linear-gradient(279deg, #121a3c, #652641 10%, #dd3747 38%, #e73948 50%, #fe3c49);
  `;
}

export function pageFadeIn(timer = 0.3) {
  return css`
    opacity: 0;
    animation: ${showPage} ${timer}s ease-in ${timer}s;
    animation-fill-mode: forwards;
  `;
}
